<div fxLayout="column">
  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
    <img src="/assets/iconography/booking.svg" class="booking-logo" />
    <h2 class="nomargin">Requirements</h2>
  </div>

  <ng-container *ngIf="disclaimerPage === 1">
    <p>How do you price your Booking.com properties?</p>

    <div
      fxLayout="column"
      fxLayoutAlign="start stretch"
      fxLayoutGap="12px"
      fxLayout.lt-md="column"
      class="selection__wrapper">
      <div
        fxFlex
        class="selection__box"
        [class.selection__box-selected]="pricingType === 'standard'"
        fxLayout="column"
        fxLayoutGap="16px"
        (click)="pricingType = 'standard'; progress()">
        <div fxLayout fxLayoutGap="12px">
          <strong fxFlex>Only standard pricing</strong>
        </div>
        <div class="text__small">I only use rates which do not change based on occupancy.</div>
      </div>
    </div>

    <div
      fxLayout="column"
      fxLayoutAlign="start stretch"
      fxLayoutGap="12px"
      fxLayout.lt-md="column"
      class="selection__wrapper">
      <div
        fxFlex
        class="selection__box"
        [class.selection__box-selected]="pricingType === 'other'"
        fxLayout="column"
        fxLayoutGap="16px"
        (click)="pricingType = 'other'; progress()">
        <div fxLayout fxLayoutGap="12px">
          <strong fxFlex>Other pricing types</strong>
        </div>

        <div class="text__small">My properties uses other pricing types, such as occupancy based pricing.</div>
      </div>
    </div>

    <p class="grass-darker text-left">
      <a href="{{ disclaimerPage | bookingConnectionDocumentationPipe }}" target="_blank">Not sure what this means?</a>
    </p>
  </ng-container>

  <ng-container *ngIf="disclaimerPage === 2">
    <div class="question-box">
      <div fxLayout="column" fxLayoutGap="12px">
        <strong fxFlex>
          Do you have any Booking.com properties which list multiple rooms or units in bulk, rather than each having
          it's own listing?
        </strong>
        <div class="text__small night-lighter">ex. BnB with 2 queen bedrooms which are listed as one room</div>
        <mat-radio-group
          aria-label="Select an option"
          [(ngModel)]="multipleRooms"
          fxLayout="column"
          (change)="progress()">
          <div><mat-radio-button class="full-width-radio-button" [value]="true">Yes</mat-radio-button></div>
          <div><mat-radio-button class="full-width-radio-button" [value]="false">No</mat-radio-button></div>
        </mat-radio-group>
      </div>
    </div>

    <div class="question-box">
      <div fxLayout="column" fxLayoutGap="12px">
        <strong fxFlex>Do you have any calendars connected or imported into this account via iCal?</strong>
        <mat-radio-group
          aria-label="Select an option"
          [(ngModel)]="iCalsImported"
          fxLayout="column"
          (change)="progress()">
          <div><mat-radio-button class="full-width-radio-button" [value]="true">Yes</mat-radio-button></div>
          <div><mat-radio-button class="full-width-radio-button" [value]="false">No</mat-radio-button></div>
        </mat-radio-group>
      </div>
    </div>

    <!-- <section>
      <div
        fxLayout
        fxLayoutGap="18px"
        fxLayoutAlign="end center"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center stretch"
      >
        <button mat-flat-button (click)="progress()" [disabled]="multipleRooms == null || iCalsImported == null">Continue</button>
      </div>
    </section> -->
  </ng-container>
</div>
